import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'

import { connect } from "react-redux";
import ReactTable from 'react-table';
function NewProjectProductList(props) {
  // const [asins,setAsins]=useState([])
  const [asins, setAsins] = useState(
    props.asinList && Array.isArray(props.asinList) ? props.asinList.map(String) : []
  );
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    setAsins(
      props.asinList && Array.isArray(props.asinList)
        ? Array.from(new Set(props.asinList.map(String)))
        : []
    );
  }, [props.asinList]);

  // const selectedAsinList = (asin) => {
  //   setAsins(prev => {
  //     const normalized = prev.map(String);
  //     if (normalized.includes(String(asin))) {
  //       return normalized.filter(item => item !== String(asin));
  //     } else {
  //       return Array.from(new Set([...normalized, String(asin)]));
  //     }
  //   });
  // };
  const selectedAsinList = (asin) => {
    const asinStr = String(asin);
    const selectedProduct = props.productList.find(p => String(p.asin) === asinStr);
  
    if (!selectedProduct) return;
  
    const isParent = selectedProduct.isParentProduct;
  
    setAsins(prev => {
      let updatedAsins = [...prev.map(String)];
  
      if (isParent) {
        const childAsins = props.productList
          .filter(p => String(p.parentProduct) === asinStr && String(p.asin) !== asinStr)
          .map(p => String(p.asin));
  
        if (updatedAsins.includes(asinStr)) {
          updatedAsins = updatedAsins.filter(item => item !== asinStr && !childAsins.includes(item));
        } else {
          updatedAsins.push(asinStr, ...childAsins);
        }
  
      } else {
        if (updatedAsins.includes(asinStr)) {
          updatedAsins = updatedAsins.filter(item => item !== asinStr);
        } else {
          updatedAsins.push(asinStr);
        }
      }
  
      return Array.from(new Set(updatedAsins));
    });
  };  
 
    const handleStoreWiseProducts=()=>{
      props.setAsinList(asins)
      props.setAddProductsPopup(false)
    
    }
    const columns = [
        {
            Header: "Select",
            accessor: "asin",
            width:80,
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                
                <input
                    onChange={() => selectedAsinList(cellInfo.value)}
                    value={cellInfo.value}
                    type="checkbox"
                    name={cellInfo.value}
                    checked={asins && asins.includes(cellInfo.value)}
                  />
              </div>
            ),
          },
          {
            Header: "Parent Asin",
            accessor: "parentProduct",
            width: 110,
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                <p className='mb-0'>{cellInfo.value}</p>
              </div>
            ),
          },
        {
          Header: "Asin",
          accessor: "asin",
          width: 110,
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-center w-100">
              
              <p className='mb-0'>{cellInfo.value}</p>
            </div>
          ),
        },
        // {
        //   Header: "IsParent",
        //   accessor: "isParentProduct",
        //   Cell: (cellInfo) => (
        //     <div className="d-flex justify-content-center w-100">
        //       <p className='mb-0'>{cellInfo.value ? "Yes" : "No"}</p>
        //     </div>
        //   ),
        // },
        {
          Header: "Product Title",
          accessor: "productTitle",
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-start w-100">
              <p title={cellInfo.value}className='mb-0 comment-paragraph-Amazon-Alert-table'>{cellInfo.value}</p>
            </div>
          ),
        },
        
         
        ]
   
      const filterProductData = props.productList && props.productList
      .filter((row) => {
        const parentProduct = (row.parentProduct || '').toLowerCase();
        const isParentProduct = row.isParentProduct ? 'yes' : 'no';
        const productTitle = (row.productTitle || '').toString().toLowerCase();
        const asin = (row.asin || '').toString().toLowerCase();
        return (
          isParentProduct.includes(searchText.toLowerCase()) ||
          parentProduct.includes(searchText.toLowerCase()) ||
          asin.includes(searchText.toLowerCase()) ||
          productTitle.includes(searchText.toLowerCase())
        );
      })
      .sort((a, b) => {
        const hasParentA = !!a.parentProduct;
        const hasParentB = !!b.parentProduct;

        if (hasParentA && !hasParentB) return -1; 
        if (!hasParentA && hasParentB) return 1;  
        
        if (hasParentA && hasParentB) {
            return a.parentProduct.localeCompare(b.parentProduct);
        }
        
        return 0;
      });
    
  return (
   <>
     <Card className='curve-popup p-3'>
          <Row>
              <Col md={6}>
                <Input
                  className="mb-2 w-100"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search Product by Title and ASIN "
                />
              </Col>
            <Col md={12}>
            <ReactTable
                      data={filterProductData}
                      columns={columns}
                      className="-fixed -highlight -striped mt-2"
                      getTheadProps={() => ({
                        style: {
                          overflowY: "hidden",
                          background: "#B1FA63",
                          color: "#243837",
                        },
                      })}
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct) {
                          return {
                            style: {
                              backgroundColor: '#dfd7ff', 
                            },
                          };
                        }
                        return {};
                      }}
                      defaultPageSize={10}
                      noDataText={"No Data Found."}
                    />
            </Col>
          
            <Col className="d-flex justify-content-center mt-2">
              <Button
                className="btn-background-color"
                // disabled={selectedStoreData.integerId && emailRecipient ? false : true}
                onClick={() => handleStoreWiseProducts()}
                >
                Done
              </Button>
            </Col>
          </Row>
        </Card>
   </>
  )
}

const mapStateToProps = (state) => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
      error: state.loggedUser.error,
  
    };
  };
  
  export default connect(mapStateToProps)(NewProjectProductList);